import { AccountMultipleOutlineIcon } from './AccountMultipleOutlineIcon';

/**
 * author: Google
 * id 30C6B7FE-4496-4961-B36F-E0FBC4F2696E
 * name account-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-outline.svg
 * tags
 * - Account / User 
 */
export const UsersOutlineIcon = AccountMultipleOutlineIcon;
export default UsersOutlineIcon